import {Component ,ViewChild, Injectable } from '@angular/core';
import {NavController,ToastController,AlertController,ModalController} from 'ionic-angular';
import { Headers , RequestOptions } from '@angular/http';
import {ItemsPage} from "../items/items";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {Api} from '../../providers/api';
import {ApiOffline} from '../../providers/api-offline';
import {CART, Customer, loginUserInfo, STOCKCART} from '../../providers/data';
import {IMAGES_BASE_URL ,Constants,ApplicationVariables} from '../../providers/config';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import {NavParams } from 'ionic-angular';
import {Printer, PrintOptions} from 'ionic-native';
import {GVLogger} from '../../services/gv-logger';
import  {LoginPage} from '../login/login';
import {MyOrderPage} from '../my-order/my-order';
import {ThankYouModalPage} from '../thank-you-modal/thank-you-modal';
import {isIntelliStock} from '../../providers/config'

import { DatePickerProvider } from 'ionic2-date-picker';
import {DropshipLocationAddPopup} from '../dropship-location-add-popup/dropship-location-add-popup';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import {ConfirmPasswordPopup} from "../confirm-password-popup/confirm-password-popup";
// import { loginUserInfo} from '../../providers/data';

@Component({
  selector: 'page-order-confirm',
  templateUrl: 'order-confirm.html',
  providers:[ ]
})
@Injectable()
export class OrderConfirmPage {

  isOfflineMode:any = false;

  shippingServicesAll:any = [];

  constants = Constants;
  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
  todayDate:any;
  // Coding for signature
  signature = '';
  isDrawing = false;
  currentDate;
  placeOrderButton = true;
  drawPad = false;
  signaturedPad = true;
  hidePencil = false;
  salesPerson;
  shipto = '';
  customPricingEnabled = 0;
  passwordApproved = false;
  customPricing = false;

  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  signaturePadOptions: Object = { // Check out https://github.com/szimek/signature_pad
    // 'minWidth': 2,
    'canvasWidth': 500,
    'canvasHeight': 250,
    'backgroundColor': '#ffffff',
    'penColor': '#666a73'
  };


  cacheImages = false;

  public cart: any;
  public TotalPrice: number =0;
  public TotalPriceBeforeTax: number = 0;
  public taxPercent = 0; // Changed from 0.13
  public taxAmount = 0;
  public locationSelected: any;
  public locationSelectedObject: any;
  public expectedShipmentDate: any;
  public orderMessage = "";
  cacheImagesTag = "cacheImages";
  shippingServiceId = 0;
  shippingServiceValue = "";
  shippingService:any = {
    shippingServiceId:"",
    shippingServiceValue:""
  };

  adpCustomerInfo:any = {};
  space: string = ", ";
  spaceAddress1 : string;
  spaceAddress2 : string;
  spaceCity: string;
  spaceState: any;
  spaceZipCode: any;
  isIntelliStockfunc=isIntelliStock;
  stockCart: any;
  selectFirstBillTo : any;
  shipmentCharges = loginUserInfo.customerShippingCost;
  private isDropShip = 0;


  public uploader: FileUploader = new FileUploader({});
  public hasBaseDropZoneOver: boolean = false;
  customerOrderNumber;
  userName = "";
  password = "";

  taxPercentage = 0;
  selectedCurrency = ""


  constructor(public nav: NavController,
              private cartManager:CartManager,
              private api:Api,public storage: Storage,
              public toastCtrl: ToastController,
              public params:NavParams,
              public alertCtrl: AlertController,
              public msgManager:MsgManager,
              private gVLogger:GVLogger,
              private apiOffline:ApiOffline,
              private modalCtrl:ModalController,
              private datePickerProvider:DatePickerProvider) {

    this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    this.getAllShippingServies();


    this.storage.get(this.cacheImagesTag).then((cache)=>{
      this.cacheImages = cache;
    });

    this.isOfflineMode = ApplicationVariables.isOffline;

    this.salesPerson = this.cartManager.getSalesPerson();

    this.gVLogger.log(this.salesPerson);

    // this.orderMessage = this.cartManager.getOrderMessage();
    this.gVLogger.log("orderMessage : ");
    this.gVLogger.log(this.orderMessage);
    if(this.orderMessage !== undefined && this.orderMessage !== null){
      let  splittedMessage = this.orderMessage.split("&nbsp;<");
      this.orderMessage = splittedMessage[0];
    }
    // this.expectedShipmentDate = this.cartManager.getShipDate(); // QNS
    this.gVLogger.log("Expected ship Date : "+this.expectedShipmentDate);
    this.signature = "assets/img/screenshot-1.png";

    var today = new Date();
    this.gVLogger.log(today);

    let dd:any = today.getDate();
    if( dd>0 && dd<10){
      dd = "0"+dd;
    }
    let mm:any = today.getMonth()+1; //January is 0!
    if( mm>0 && mm<10){
      mm = "0"+mm;
    }
    var yyyy = today.getFullYear();

    this.todayDate = yyyy+"-"+mm+"-"+dd;
    this.gVLogger.log(this.todayDate);
    this.placeOrderButton = true;
    this.cart = CART;
    this.stockCart = STOCKCART;
    //this.expectedShipmentDate = "";
    this.gVLogger.log(CART);
    this.currentDate = new Date();
    this.TotalPriceBeforeTax = params.get("TotalPrice");
    this.locationSelected = params.get("locationSelected");

    this.refreshTotalPrice();
    // this.taxAmount = this.TotalPriceBeforeTax  * this.taxPercent;
    this.taxAmount = this.cart.totalTax;
    console.log("this.taxAmount.taxAmount " + this.taxAmount)
    console.log("this.TotalPriceBeforeTax.TotalPriceBeforeTax " + this.TotalPriceBeforeTax)
    this.TotalPrice = this.TotalPriceBeforeTax + this.taxAmount;
    console.log("this.TotalPrice.TotalPrice " + this.TotalPrice)
    this.getLocationById();
    this.updateOrderMessageInCART();
    this.storage.remove('savedSignature');
    this.gVLogger.log("Total price : ");
    this.gVLogger.log(this.TotalPrice);

    console.log("Cusddddddddddddddddddddddddddd " + loginUserInfo.customPricing)
    this.customPricingEnabled = loginUserInfo.customPricing

    // if(this.customPricingEnabled === 1)
    for(let item of this.cart.items){
      item.priceBeforeCustomPricing = item.price
    }

    if(loginUserInfo.multiCurrencyFlag === 1 && Customer.paymentCurrency !== undefined && Customer.paymentCurrency !== "")
      this.selectedCurrency = Customer.paymentCurrency;
    else
      this.selectedCurrency = this.adpCustomerInfo.selectedCurrencySymbol


    if(this.locationSelectedObject !== undefined && this.locationSelectedObject !== null)
      this.calculateTax()
  }



  refreshTotalPrice(){
    this.cart = CART;
    let temp:number = 0;
    for(let item of this.cart.items){
      if(item.customPricing){
          temp =  temp + (Number(item.selectedCustomPrice) * Number(item.quantity));
      }else {
        if(this.discountCheck(item.discountPrice)){
          item.discountPrice = this.decimalLengthFixed(item.discountPrice,2)
          temp =  temp + (Number(item.discountPrice) * Number(item.quantity));
        }else{
          item.price = this.decimalLengthFixed(item.price,2)
          temp =  temp + (Number(item.price) * Number(item.quantity));
        }
      }

    }
    this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
    this.TotalPrice = this.TotalPriceBeforeTax + this.taxAmount;
    // this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    // this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
    //alert(JSON.stringify(this.cart));
  }


  showCalendar(){

    const dateSelected =  this.datePickerProvider.showCalendar(this.modalCtrl);


    dateSelected.subscribe(date => {
      this.gVLogger.log(date);
      var d = new Date(""+date);
      let dd:any = d.getDate();
      if( dd>0 && dd<10){
        dd = "0"+dd;
      }
      let mm:any = d.getMonth()+1; //January is 0!
      if( mm>0 && mm<10){
        mm = "0"+mm;
      }
      var output = d.getFullYear() +"-"+  mm + "-" + dd;

      this.expectedShipmentDate = output;
      this.gVLogger.log(output);
      this.cartManager.setShipDate(this.expectedShipmentDate);
    });
  }

  getLocationById(){
    if(this.cart.tempShipTo === undefined){

      for(let loc of this.cart.customer.locationsDTOs){
        this.gVLogger.log("location dt0000000000000000000000000000000000" +
          "0000000000000000000000000000000000000000000000000000o " + JSON.stringify( loc));
        if(loc.locationType === "SHIPTO" || loc.locationType === "BILLTOSHIPTO"){
          if(loc.id == this.locationSelected){
            this.locationSelectedObject = loc;
            this.gVLogger.log(this.locationSelectedObject);
            this.setCommaAddress1();
            this.setCommaAddress2();
            this.setCommaCity();
            this.setCommaState();
            this.setCommaZipCode();
            this.shipto = [this.locationSelectedObject.addressLine1, this.spaceAddress1, this.locationSelectedObject.addressLine2, this.spaceAddress2, this.locationSelectedObject.city, this.spaceCity, this.locationSelectedObject.state, this.spaceState, this.locationSelectedObject.zipCode, this.spaceZipCode, this.locationSelectedObject.country].join("");
            // }
          }

        }else if(loc.locationType === "BILLTO" && this.shipto === ""){
          this.shipto = "Undefined";
        }


      }
    }
    else
    {
      this.gVLogger.log("from unhold to review order --- " );

      this.locationSelectedObject = this.cart.tempShipTo;
      this.setCommaAddress1();
      this.setCommaAddress2();
      this.setCommaCity();
      this.setCommaState();
      this.setCommaZipCode();
      this.shipto = [this.locationSelectedObject.addressLine1, this.spaceAddress1, this.locationSelectedObject.addressLine2, this.spaceAddress2,  this.locationSelectedObject.city, this.spaceCity, this.locationSelectedObject.state, this.spaceState, this.locationSelectedObject.zipCode, this.spaceZipCode, this.locationSelectedObject.country].join("");
    }

    this.shipmentCharges = this.locationSelectedObject.shippingCost;

  }

  setCommaState(){
    if(this.locationSelectedObject.state === "" || this.locationSelectedObject.state === undefined || this.locationSelectedObject.state === null)
    {
      this.spaceState = "";
    }
    else
    {
      this.spaceState = ", ";
    }
  }

  setCommaZipCode(){
    if(this.locationSelectedObject.zipCode === "" || this.locationSelectedObject.zipCode === undefined || this.locationSelectedObject.zipCode === null)
    {
      this.spaceZipCode = "";
    }
    else
    {
      this.spaceZipCode = ", ";
    }
  }

  setCommaCity(){
    if(this.locationSelectedObject.city === "" || this.locationSelectedObject.city === undefined || this.locationSelectedObject.city === null)
    {
      this.spaceCity = "";
    }
    else
    {
      this.spaceCity = ", ";
    }
  }

  setCommaAddress1(){
    if(this.locationSelectedObject.addressLine1 === "" || this.locationSelectedObject.addressLine1 === undefined || this.locationSelectedObject.addressLine1 === null)
    {
      this.spaceAddress1 = "";
    }
    else
    {
      this.spaceAddress1 = " ";
    }
  }

  setCommaAddress2(){
    if(this.locationSelectedObject.addressLine2 === "" || this.locationSelectedObject.addressLine2 === undefined || this.locationSelectedObject.addressLine2 === null)
    {
      this.spaceAddress2 = "";
    }
    else
    {
      this.spaceAddress2 = ", ";
    }
  }

  orderPlaceRosolver(){

    if(ApplicationVariables.isOffline){
      this.orderPlaceoffline();
    }else{
      this.buy();
    }


  }

  orderPlaceoffline(){

    if(this.expectedShipmentDate == ""){
      this.msgManager.toastMsg("Please select a Shipment Date");
    }else{

      this.placeOrderButton = false;


      var body:any = this.cartManager.genrateOrder(1, this.shipmentCharges); // placeorder status 1


      this.apiOffline.insertOrder(JSON.stringify(body))
        .then((data) => {
          // alert(JSON.stringify(data));
          this.cartManager.clearCart();
          this.cartManager.setOrderId(0); // orderid after submission
          this.cartManager.setOrderMessage("");
          this.cartManager.setOrderTitle("");
          this.cartManager.setShipingServiceName("");
          this.cartManager.setShippingServiceId("");
          this.storage.remove('savedSignature');
          // this.presentThankYouAlert("We thank you for placing the order!","A copy of the order has been sent to you and your customer.\nPlease confirm that you have received the email (It may take couple of minutes).");
          this.presentThankYouAlert("Thank you for your order!","A confirmation email has been sent to your inbox. If you have any questions, feel free to contact us (Please find contact details inside the email).");

          //this.msgManager.toastMsg(this.msgManager.getOrderPlaceSuccessMsg());
          if(this.isIntelliStockfunc){
            this.nav.setRoot(MyOrderPage);
          }else
            this.nav.setRoot(ItemsPage).then(()=>{
              //this.nav.push(MyOrderPage);
            });
        })
        .catch(e => this.gVLogger.log(e));




    }

  }


  // place order
  buy() {

    //this.placeOrderButton = false;
    this.gVLogger.log("EXPECTED SHIPMENT DATE : " + this.expectedShipmentDate);

    if(this.expectedShipmentDate == "" || this.expectedShipmentDate == undefined){
      this.msgManager.toastMsg("Please select a Shipment Date");
    }else if(this.customerOrderNumber === "" || this.customerOrderNumber === undefined || this.customerOrderNumber.trim() === ""){
      this.msgManager.toastMsg("Customer order number can't be empty.");
    }else{
      this.placeOrderButton = false;
      let body = {
        customerOrderNumber : this.customerOrderNumber,
        customerId : CART.customer.id
      }
      // this.api.get("order/getByCustomerOrderNumber?custOrderNumber="+this.customerOrderNumber+"&custId="+CART.customer.id).map(res => res.json()).subscribe(data => {
      this.api.post("order/checkByCustomerOrderNumber", body).map(res => res.json()).subscribe(data => {
        if(data.status === "403"){
          let custNumber = this.customerOrderNumber
          if(custNumber !== undefined && custNumber !== null){
            custNumber = custNumber.trim();
          }
          var body:any = this.cartManager.genrateOrderFromConfirmOrderPage(1, this.shipmentCharges, custNumber, this.shippingServiceValue, this.taxAmount,loginUserInfo.firstName,loginUserInfo.lastName); // placeorder status 1

          console.log("Sleedted location objectttttttttttttttttt : " + JSON.stringify(this.locationSelectedObject))
          body.customerDTO.locationsDTOs[0].dropshipLocation = JSON.stringify(this.locationSelectedObject);
          body.customerDTO.locationsDTOs[0].isDropShipAddress = this.isDropShip;
          body.userName = this.userName
          body.password = this.password

          this.gVLogger.log(JSON.stringify(body));

          this.gVLogger.log(JSON.stringify(body));
          let headers = new Headers({
            'Content-Type': 'application/json'
          });
          let options = new RequestOptions({
            headers: headers
          });
          //this.saveOrderOnDisk();

          this.gVLogger.log("Order placed request payload --- ARM"+body);

          this.api.post("order/place",JSON.stringify(body), options)
            .map(res => res.json())
            .subscribe(resp => {
                if(resp.status="200"){

                  this.passwordApproved = false

                  this.upload(resp.data);


                  this.cartManager.clearCart();
                  this.cartManager.setOrderId(0); // orderid after submission
                  this.cartManager.setOrderMessage("");
                  this.cartManager.setOrderTitle("");
                  this.cartManager.setShipingServiceName("");
                  this.cartManager.setShippingServiceId("");
                  this.storage.remove('savedSignature');
                  this.cart.tempShipTo = undefined;

                  if(Constants.isWebstore){
                    this.presentThankYouAlert("Thank you for your order!","A confirmation email has been sent to your inbox. If you have any questions, feel free to contact us (Please find contact details inside the email).");
                  }else{
                    this.presentThankYouAlert("Thank you for your order!","A confirmation email has been sent to your inbox. If you have any questions, feel free to contact us (Please find contact details inside the email).");
                  }

                  //this.msgManager.toastMsg(this.msgManager.getOrderPlaceSuccessMsg());
                  // if(this.is)
                  if(this.isIntelliStockfunc){
                    this.nav.setRoot(MyOrderPage);
                  }else
                    this.nav.setRoot(ItemsPage).then(()=>{
                      //this.nav.push(MyOrderPage);
                    });
                }else if(resp.status == "401"){ // check for session out
                  this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                  this.nav.setRoot(LoginPage);
                }

              }
              , error =>{
                this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
                //alert(JSON.stringify(error));
              });

        }else {
          this.msgManager.toastMsg("Order with same customer order number already exist.");
          this.placeOrderButton = true;

        }
      })

      // this.placeOrderButton = false;
      //
      //
      // let custNumber = this.customerOrderNumber
      // if(custNumber !== undefined && custNumber !== null){
      //   custNumber = custNumber.trim();
      // }
      // var body:any = this.cartManager.genrateOrderFromConfirmOrderPage(1, this.shipmentCharges, custNumber, this.shippingServiceValue, this.taxAmount); // placeorder status 1
      //
      // console.log("Sleedted location objectttttttttttttttttt : " + JSON.stringify(this.locationSelectedObject))
      // body.customerDTO.locationsDTOs[0].dropshipLocation = JSON.stringify(this.locationSelectedObject);
      // body.customerDTO.locationsDTOs[0].isDropShipAddress = this.isDropShip;
      //
      // this.gVLogger.log(JSON.stringify(body));
      //
      // this.gVLogger.log(JSON.stringify(body));
      // let headers = new Headers({
      //   'Content-Type': 'application/json'
      // });
      // let options = new RequestOptions({
      //   headers: headers
      // });
      // //this.saveOrderOnDisk();
      //
      // this.gVLogger.log("Order placed request payload --- ARM"+body);
      //
      // this.api.post("order/place",JSON.stringify(body), options)
      //   .map(res => res.json())
      //   .subscribe(resp => {
      //       if(resp.status="200"){
      //
      //         this.upload(resp.data);
      //
      //
      //         this.cartManager.clearCart();
      //         this.cartManager.setOrderId(0); // orderid after submission
      //         this.cartManager.setOrderMessage("");
      //         this.cartManager.setOrderTitle("");
      //         this.cartManager.setShipingServiceName("");
      //         this.cartManager.setShippingServiceId("");
      //         this.storage.remove('savedSignature');
      //         this.cart.tempShipTo = undefined;
      //
      //         if(Constants.isWebstore){
      //           this.presentThankYouAlert("We thank you for placing the order!","A copy of the order has been sent to you and your local representative.\nPlease confirm that you have received the email (It may take couple of minutes).");
      //         }else{
      //           this.presentThankYouAlert("We thank you for placing the order!","A copy of the order has been sent to you and your customer.\nPlease confirm that you have received the email (It may take couple of minutes).");
      //         }
      //
      //         //this.msgManager.toastMsg(this.msgManager.getOrderPlaceSuccessMsg());
      //         // if(this.is)
      //         if(this.isIntelliStockfunc){
      //           this.nav.setRoot(MyOrderPage);
      //         }else
      //           this.nav.setRoot(ItemsPage).then(()=>{
      //             //this.nav.push(MyOrderPage);
      //           });
      //       }else if(resp.status == "401"){ // check for session out
      //         this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
      //
      //         this.nav.setRoot(LoginPage);
      //       }
      //
      //     }
      //     , error =>{
      //       this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
      //       //alert(JSON.stringify(error));
      //     });



      // back to home page
      // this.nav.setRoot(HomePage);
    }

  }
  doSignature(){
    this.drawPad = true;
    this.signaturedPad = false;
  }
  // Coding starts for signature right here
  ionViewDidEnter() {
    this.gVLogger.log("Signature pad");
    if(this.signaturePad){
      this.signaturePad.clear();
    }
    this.storage.get('savedSignature').then((data) => {
      this.gVLogger.log('savedSignature --- '+ data)
      if(data != null)
        this.signature = data;
    });
  }


  decimalLengthFixedWithShippingCost(num,max){
    // this.gVLogger.log("cccccccccccccccccccccccccccccccccccccccccccccccccccccc" + Number(loginUserInfo.customerShippingCost))
    // let total = Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length)) ;
    let totalAmount = Number(num);
    if(this.shipmentCharges != "" && Number(this.shipmentCharges) !== NaN){
      totalAmount = Number(num) + Number(this.shipmentCharges);
      // return totalAmount;
    }
    // let totalAmount = Number(num) + Number(this.shipmentCharges);
    // return totalAmount.toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
    return totalAmount.toFixed(2)
  }


  drawComplete() {
    this.isDrawing = false;
  }

  drawStart() {
    this.isDrawing = true;
  }

  savePad() {
    this.drawPad = false;
    this.signaturedPad = true;
    this.hidePencil = true;
    this.signature = this.signaturePad.toDataURL();
    this.storage.set('savedSignature', this.signature);
    this.signaturePad.clear();

    this.placeOrderButton = true;
  }
  clearPad() {
    this.signaturePad.clear();
  }

  clearCart(){
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: 'Do you agree to Clear all the Products from cart',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            this.gVLogger.log('Agree clicked');
            this.cartManager.clearCartProducts();
            this.nav.pop().then(()=>{this.nav.pop()});
          }
        }
      ]
    });
    confirm.present();

  }

  saveOrderOnDisk(){

    // let keys: any = [];

    // let arrKeys = JSON.parse( localStorage.getItem("keys"));
    // let key = this.cart.customer.id + "-" + new Date();
    // alert(arrKeys);
    // if(arrKeys == null){
    //   keys.push(key);
    //   localStorage.setItem("keys",keys);
    //   localStorage.setItem(key,JSON.stringify(this.cart));
    // }else{
    //     arrKeys.push(key);
    //     localStorage.setItem("keys",arrKeys);
    //     localStorage.setItem(key,JSON.stringify(this.cart));
    // }


  }

  shipDateChanged(event){
    //this.expectedShipmentDate = true;
    this.gVLogger.log("shipDateChanged called");
    this.gVLogger.log(this.expectedShipmentDate);
    this.cartManager.setShipDate(this.expectedShipmentDate);
  }

  updateOrderMessageInCART(){
    this.cartManager.setOrderMessage(this.orderMessage);
  }

  updateOrderMessage($event){
    this.gVLogger.log("Blured called : ");
    this.gVLogger.log(this.orderMessage);
    this.updateOrderMessageInCART();
  }

  doPrint(){
    let options: PrintOptions = {
      name: 'Purchase Order'
    };

    Printer.isAvailable().then(
      function(){
        //alert("Printer is available");
        Printer.print(document.getElementById("print-from"), options).then(function(){},function(){});
      }
      ,
      function(){
        alert("Printer is not available");
      }
    );
  }



  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }


  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

  getPrice(product){
    console.log("prdyctttttt " + product.discountPrice)
    if(Number(product.discountPrice) > 0){
      return product.discountPrice;
    }else{
      return product.price;
    }
  }

  decimalLengthFixed(num,max){
    // return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
    return Number(num).toFixed(2)
  }





  doPrintWeb(){

    this.printToCart("print-from");

  }


  printToCart(printSectionId: string){
    let popupWinindow;
    let innerContents = document.getElementById(printSectionId).innerHTML;
    popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
    popupWinindow.document.close();
  }


  presentThankYouAlert(title,msg){
    let thankyouModal = this.modalCtrl.create(ThankYouModalPage, { title: title ,message: msg });
    thankyouModal.present();
  }


  makeImageURL(dimensions,item){
    return this.cartManager.makeImageURL(dimensions,item);
  }


  getSquareLogo(){
    return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000);
  }




  // getAllShippingServies(){
  //   this.api.geJazzba("lookups/search/%20/0/100/shippingServices").map(res=>res.json())
  //   .subscribe((result)=>{
  //     this.shippingServicesAll = result.lookups;
  //   },(err)=>{
  //
  //   });
  // }

  getAllShippingServies(){
    // this.api.geJazzba("lookups/search/%20/0/100/shippingServices").map(res=>res.json())
    this.api.get("lookup/shippingServices?customerId="+Customer.id).map(res=>res.json())
      .subscribe((result)=>{
        if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.nav.setRoot(LoginPage);
        }
        this.shippingServicesAll = result.data;
      },(err)=>{

      });
  }

  updateShippingService(){


    for(let s of this.cart.customer.shippingServiceDTOs){
      if(s.id == this.shippingServiceId){
        this.shippingService = s;
      }
    }

    this.gVLogger.log(this.shippingService);

    this.cartManager.setShipingServiceName(this.translateShippingServiceID(this.shippingService.shippingServiceId));
    this.cartManager.setShippingServiceId(this.shippingService.shippingServiceValue);
  }

  translateShippingServiceID(id){
    for(let s of this.shippingServicesAll){
      if(s.id == id)
        return s.description;
    }
  }

  DropshipLocation(){
    this.gVLogger.log("Add Dropship Location");
    let modal = this.modalCtrl.create(DropshipLocationAddPopup, {dropshipLocation:JSON.parse(JSON.stringify(this.locationSelectedObject)), companyName:this.cart.customer.name});
    modal.onDidDismiss(data => {
      if(data!=null){
        this.gVLogger.log("After add popup --- "+ data);
        if(data !== false)
        {

          CART.customer.name = data.companyName
          this.cart.customer.name = data.companyName

          this.isDropShip = 1;

          this.locationSelectedObject = data;
          this.gVLogger.log(this.locationSelectedObject);
          this.cart.tempShipTo = this.locationSelectedObject;
          // this.shipto = [this.locationSelectedObject.addressLine1,  this.locationSelectedObject.city, this.locationSelectedObject.state, this.locationSelectedObject.country].join();
          this.setCommaAddress1();
          this.setCommaAddress2();
          this.setCommaCity();
          this.setCommaState();
          this.shipto = [this.locationSelectedObject.addressLine1, this.spaceAddress1, this.locationSelectedObject.addressLine2, this.spaceAddress2, this.locationSelectedObject.city, this.spaceCity, this.locationSelectedObject.state, this.spaceState, this.locationSelectedObject.zipCode, this.spaceZipCode, this.locationSelectedObject.country].join("");

          this.calculateTax()


          // let orderProducts = []
          // for(let item of CART.items){
          //   var orderDetailDTOs: any = {
          //
          //     "productsDTO":item,
          //     "quantity": item.quantity,
          //   };
          //
          //   orderProducts.push(orderDetailDTOs);
          // }
          //
          // let body = {
          //   "id":CART.orderId,
          //   "salesManId":CART.user.id,
          //   "orderMessage":CART.orderMessage,
          //   "expectedShipmentDate": CART.expectedShipmentDate,
          //   "totalTexAmount":"10",
          //   "orderStatus":status,
          //   "customerDTO":CART.customer,
          //   "orderDetailDTOs": orderProducts,
          // }
          //
          // body.customerDTO.locationsDTOs[0].dropshipLocation = JSON.stringify(this.locationSelectedObject);
          //
          //
          // this.api.post("tax/getOrderTax",JSON.stringify(body)).map(res => res.json()).subscribe(data => {
          //   if(data.status == "200"){
          //
          //     console.log("CART.totalTaxCART.totalTax " + data.data)
          //     CART.totalTax = data.data;
          //     this.taxAmount = data.data;
          //     console.log("this.taxAmount.taxAmount " + this.taxAmount)
          //     console.log("this.TotalPriceBeforeTax.TotalPriceBeforeTax " + this.TotalPriceBeforeTax)
          //     this.TotalPrice = this.TotalPriceBeforeTax + this.taxAmount;
          //     // this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});
          //   }
          //
          // })


        }

      }


    });
    modal.present();

  }

  calculateTax(){
    let orderProducts = []
    for(let item of CART.items){
      if(item.customPricing)
        item.price = item.selectedCustomPrice
      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
      };

      if(item.price !== undefined && item.price !== null && item.price !== "")
        orderProducts.push(orderDetailDTOs);
    }

    let body = {
      "id":CART.orderId,
      "salesManId":CART.user.id,
      "orderMessage":CART.orderMessage,
      "expectedShipmentDate": CART.expectedShipmentDate,
      "totalTexAmount":"10",
      "orderStatus":status,
      "customerDTO":CART.customer,
      "orderDetailDTOs": orderProducts,
      "customPricing" : this.customPricing
    }

    // console.log("SELECTED LOCSTION OBJECTCCCCC " + JSON.stringify(this.locationSelectedObject))
    // for(let loc of body.customerDTO.locationsDTOs){
    //   if(loc.id === this.locationSelected){
    // let loc = this.locationSelectedObject
    // let location = JSON.stringify(loc)
    // location = JSON.parse(location)
    this.locationSelectedObject.dropshipLocation = ""
    // body.customerDTO.locationsDTOs[0].dropshipLocation = ""
    body.customerDTO.locationsDTOs[0].dropshipLocation = JSON.stringify(this.locationSelectedObject);
    //   }
    // }


    this.api.post("tax/getOrderTax",JSON.stringify(body)).map(res => res.json()).subscribe(data => {
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }
      if(data.status == "200"){

        console.log("CART.totalTaxCART.totalTax " + data.data.tax)
        CART.totalTax = data.data.tax;
        this.taxAmount = data.data.tax;
        this.taxPercentage = data.data.percentage;
        console.log("this.taxAmount.taxAmount " + this.taxAmount)
        console.log("this.TotalPriceBeforeTax.TotalPriceBeforeTax " + this.TotalPriceBeforeTax)
        this.TotalPrice = this.TotalPriceBeforeTax + this.taxAmount;
        // this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});
      }

    })

  }

  confirmPassword(){
    this.gVLogger.log("Add Dropship Location");
    let modal = this.modalCtrl.create(ConfirmPasswordPopup);
    modal.onDidDismiss(data => {
      if(data.status === "Verified"){
        this.gVLogger.log("After add popup --- "+ data);
        this.passwordApproved = true
        this.userName = data.userName
        this.password = data.password
        this.customPricingEnabled = 0

        for(let item of this.cart.items){
          item.selectedCustomPrice = this.getPrice(item)

        }

      }


    });
    modal.present();

  }


  disableCustomPricing(){
    let confirm = this.alertCtrl.create({
      title: 'Are you sure!',
      message: 'All custom discounts will be reverted.',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Agree',
          handler: () => {

            this.passwordApproved = false
            this.customPricing = false
            this.customPricingEnabled = 1

            for(let item of this.cart.items){
              item.price = item.priceBeforeCustomPricing
              item.customPricing = false
            }


            this.calculateTax();
            this.refreshTotalPrice()


          }
        },
      ]

    });
    confirm.present();
  }

  locationAddress1(addressLine1){
    // this.gVLogger.log("locationAddress1 called" + addressLine1);
    if(addressLine1 === "" || addressLine1 === null || addressLine1 === undefined){
      return false;
    }
    else
    {
      return true;
    }
  }

  locationTypeCheck(locationsDTOs){

    for(let loc of locationsDTOs){
      if(loc.isShipToAddress === 1 && loc.locationType === "BILLTOSHIPTO"){
        return this.selectFirstBillTo = loc;
      }
    }

    for(let loc of locationsDTOs){
      if(loc.locationType === "BILLTO"){
        return this.selectFirstBillTo = loc;
      }
    }
    for(let loc of locationsDTOs){
      if(loc.locationType === "BILLTOSHIPTO"){
        return this.selectFirstBillTo = loc;
      }
    }

    for(let loc of locationsDTOs){
      if(loc.locationType === "SHIPTO"){
        return this.selectFirstBillTo = loc;
      }
    }
  }

  ionViewDidLeave(){
    for(let item of this.cart.items){
      item.discountPrice = item.originalDiscountPrice;
      item.productDiscountDTO = null;
    }
  }


  getFiles(){

    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  deleteFile(selectedFileName){
    // console.log("QQQQQQQQQQQQQQQQQQQQQ ", this.uploader.queue.splice(1,1))

    let confirm = this.alertCtrl.create({
      title: 'Are you sure!',
      message: 'You want to delete the selected document.',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Agree',
          handler: () => {

            return this.uploader.queue.map((fileItem) => {
              if(selectedFileName === fileItem.file.name)
                fileItem.remove();
              this.msgManager.toastMsg("Document deleted successfully!");
              // alert(fileItem.file.name);
            });


          }
        },
      ]

    });
    confirm.present();


  }
  fileOverBase(ev): void {

    // alert("fileOverBase" + ev)
    this.hasBaseDropZoneOver = ev;
  }
  reorderFiles(reorderEvent: CustomEvent): void {
    let element = this.uploader.queue.splice(reorderEvent.detail.from, 1)[0];
    this.uploader.queue.splice(reorderEvent.detail.to, 0, element);
  }


  upload(orderId) {
    let files = this.getFiles();

    let formData = new FormData();
    // formData.append('uuid', localStorage.get("uuid")); // Add any other data you want to send
    // files.forEach((file) => {
    // formData.set('docs', "umar");
    for(let file of files){
      formData.append('docs', file.rawFile, file.name);
    }

    // for (var key of formData.has("docs")) {
    console.log("yyyyyyyyyyyyyyyyyyyyyy" + formData.get("docs"));


    this.api.imageUploaderPost("/uploadDocuments", formData, orderId, "orders", loginUserInfo.countryAbbrivation, this.cartManager.getADPCustomerUUID())
      .map(res => res.json())
      .subscribe(resp => {
          if(resp.status="200"){

            // do nothing
            // alert("Documents uploaded")

          }else if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }

        }
        , error =>{
          this.msgManager.toastMsg("Server error while uploading docs!");
          //alert(JSON.stringify(error));
        });
  }


  selectedCalled(event){
    var e = window.event || event;
    var target = e.target || e.srcElement;
    var files = target.files;
    var file = files[0];

    console.log("file name " + file.name)


    this.checkFile(file);
  }


  public onFileDrop(event): void {
    var e = window.event || event;
    var target = e.target || e.srcElement;
    var files = target.files;
    var file = files[0];

    console.log("file name " + file.name)

    // alert("file name " + file.name)

    // this.checkFile(file);
  }


  checkFile(file){

    let fileAlreadyExist = 0;

    this.uploader.queue.map((fileItem) => {
      if(file.name === fileItem.file.name){
        console.log("EXist file " + fileAlreadyExist)
        // fileItem.remove();

        fileAlreadyExist++;
      }



      // alert(fileItem.file.name);
    });

    // if(fileAlreadyExist === 2){
    //   this.uploader.queue.map((fileItem) => {
    //     if(file.name === fileItem.file.name){
    //       fileItem.remove();
    //       this.msgManager.toastMsg("Document already exist!");
    //       return;
    //     }
    //     // alert(fileItem.file.name);
    //   });
    // }

    if(fileAlreadyExist === 2){
      this.uploader.queue.map((fileItem) => {
        if(file.name === fileItem.file.name && fileAlreadyExist === 2){
          fileItem.remove();
          this.msgManager.toastMsg("Document with the same name already exist!");
          fileAlreadyExist = 1;
          return;
        }
        // alert(fileItem.file.name);
      });
    }


    var lastIndex = file.name.lastIndexOf('.');

    let extension = file.name.substr(lastIndex);
    let name = file.name.substr(0, lastIndex)

    if(extension !== ".csv" &&
      extension !== ".doc" &&
      extension !== ".docx" &&
      extension !== ".xlsx" &&
      extension !== ".pdf" &&
      extension !== ".png" &&
      extension !== ".jpg" &&
      extension !== ".jpeg" &&
      extension !== ".jfif" &&
      extension !== ".txt" &&
      extension !== ".zip"
    ){
      return this.uploader.queue.map((fileItem) => {
        if(file.name === fileItem.file.name){
          fileItem.remove();
          this.msgManager.toastMsg("Document format not supported!");
        }


        // alert(fileItem.file.name);
      });
    }
  }


  // public fileOver(fileIsOver: boolean): void {
  //   this.fileIsOver = fileIsOver;
  // }

  // onInPutChange(item){
  //   console.log("On XCCCCCCCCCCCCCCCCCCCC " + item.price)
  //   if(item.priceBeforeCustomPricing !== item.price && item.price > 0){
  //     item.customPricing = true
  //     this.customPricing = true
  //
  //
  //     if(item.price !== undefined && item.price !== "" && item.price !== "0"
  //       && item.price !== 0){
  //       let splitPrice = item.price.split(".")
  //
  //       if(splitPrice[1] !== undefined && splitPrice[1].length > 2){
  //         item.price = Number(item.price).toFixed(2)
  //       }
  //     }
  //     // item.productDiscountDTO.message = "Custom discount applied"
  //   }else {
  //     item.price = item.priceBeforeCustomPricing
  //     item.customPricing = false
  //   }
  //
  //   this.calculateTax()
  //   this.refreshTotalPrice()
  // }


  onInPutChange(item){
    console.log("On XCCCCCCCCCCCCCCCCCCCC " + item.selectedCustomPrice)
    if(item.priceBeforeCustomPricing !== item.selectedCustomPrice && item.selectedCustomPrice > 0){
      item.customPricing = true
      this.customPricing = true


      if(item.selectedCustomPrice !== undefined && item.selectedCustomPrice !== "" && item.selectedCustomPrice !== "0"
        && item.selectedCustomPrice !== 0){
        let splitPrice = item.selectedCustomPrice.split(".")

        if(splitPrice[1] !== undefined && splitPrice[1].length > 2){
          item.selectedCustomPrice = Number(item.selectedCustomPrice).toFixed(2)
        }
      }
      // item.productDiscountDTO.message = "Custom discount applied"
    }else {
      item.selectedCustomPrice = item.priceBeforeCustomPricing
      item.customPricing = false
    }

    this.calculateTax()
    this.refreshTotalPrice()
  }

  // ionViewWillLeave() {
  //   if (this.loading) { this.loading.dismiss() }
  // }


  ionViewCanLeave() {
    // Your logic to determine if the page can leave or not.
    // Return true if the page can leave, return false to prevent leaving.

    // For example, you can add a confirmation dialog before leaving the page:
    return this.showConfirmationDialog();
  }

  private showConfirmationDialog(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      console.log("PROMISE CALLED")
      // Implement your custom confirmation dialog here.
      // You can use any library or a custom implementation for the dialog.
      // Return a boolean value based on the user's choice.
      // For example, resolve(true) if the user confirms, resolve(false) otherwise.

      // In this example, we're just resolving with 'true' to simulate a confirmation.
      if(this.passwordApproved){
        this.api.toastMSG("Sorry! You can't go back if custom discounts enabled.")
        resolve(false)
      }

        else
        resolve(true)
    });
  }





}



// WEBPACK FOOTER //
// ./src/pages/order-confirm/order-confirm.ts